module.exports = __webpack_public_path__ + "img/beer_id-39.cea8e9d4.png";